module.exports = __webpack_public_path__ + "static/omen-0fbb124d1bd485ba91f1c6ca00d2e7ed.png";